import { Grid, IconButton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import React from "react";

interface UpDownButtonsProps {
  EditStyle_UpDown: boolean;
  inputRef: React.MutableRefObject<null | HTMLInputElement>;
  disabled?: boolean;
  inputValue: string;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
  valueChanged: React.MutableRefObject<boolean>;
}

// функции для кнопок инкремента и декремента
const incValue = (
  value: string,
  setValue: React.Dispatch<React.SetStateAction<string>>,
  valueChanged: React.MutableRefObject<boolean>,
) => {
  let val = Number(value) || 0;
  if (Number.isNaN(val)) return;
  setValue(`${val + 1}`);
  valueChanged.current = true;
};
const decValue = (
  value: string,
  setValue: React.Dispatch<React.SetStateAction<string>>,
  valueChanged: React.MutableRefObject<boolean>,
) => {
  let val = Number(value) || 0;
  if (Number.isNaN(val)) return;
  setValue(`${val - 1}`);
  valueChanged.current = true;
};

export default function UpDownButtons(props: UpDownButtonsProps) {
  const {} = props;
  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      style={{
        height: "100%",
        borderRadius: "0px",
        padding: "0",
        display: props.EditStyle_UpDown ? "" : "none",
      }}
      onMouseLeave={() => {
        if (document.activeElement !== props.inputRef.current) {
          props.inputRef?.current?.focus();
        }
        props.inputRef?.current?.blur();
      }}
    >
      <IconButton
        disabled={props.disabled}
        style={{
          width: "20px !important",
          height: "50%",
          borderRadius: "0px",
          padding: "0",
        }}
        onClick={() => {
          if (props.disabled) return;
          incValue(props.inputValue, props.setInputValue, props.valueChanged);
        }}
      >
        <ExpandLessIcon style={{ maxHeight: "10px" }} />
      </IconButton>
      <IconButton
        disabled={props.disabled}
        style={{
          width: "20px !important",
          height: "50%",
          borderRadius: "0px",
          padding: "0",
        }}
        onClick={() => {
          if (props.disabled) return;
          decValue(props.inputValue, props.setInputValue, props.valueChanged);
        }}
      >
        <ExpandMoreIcon style={{ maxHeight: "10px" }} />
      </IconButton>
    </Grid>
  );
}
